<template>
  <Form :label-width="150">
    <FormItem  label="xbed门店ID：">
      <p>{{data.xbedHotelId}}</p>
    </FormItem>
    <FormItem  label="渠道门店名称：">
      <p>{{data.xbedHotelName}}</p>
    </FormItem>
    <FormItem  label="主要联系人：">
      <p>{{data.contactPhone}}</p>
    </FormItem>
    <FormItem  label="主要联系电话：">
      <p>{{data.contactPhone}}</p>
    </FormItem>
    <FormItem  label="省份：">
      <p>{{data.province}}</p>
    </FormItem>
    <FormItem  label="城市：">
      <p>{{data.city}}</p>
    </FormItem>
    <FormItem  label="区域：">
      <p>{{data.district}}</p>
    </FormItem>
    <FormItem  label="备注：">
      <p>{{data.remark}}</p>
    </FormItem>
  </Form>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: function() {
        return {
          xbedHotelId: '',
          xbedHotelName: '',
          contactName: '',
          contactPhone: '',
          province: '',
          city: '',
          district: '',
          remark: ''
        }
      }
    }
  },
  data() {
    return {

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ota/tujia/hotel-detail/xbed-hotel-info.vue